import ReduxableService from './parentСlasses/ReduxableService'

import { setDirectory } from '../actions/service';
import * as actions from '../actions/directory';


export default class DirectoryService extends ReduxableService {

  loadQueue = []
  curentLoad=undefined
  // loaded = []

  constructor(store) {
    super(store, actions, setDirectory)
  }
  /**Ставит краткую форму справочника в очредь на загрузку и если никакой из крспр не грузится начинает загрузку */
  loadShortDirectory = (dirName) => {
    if(!this.loadQueue.includes(dirName) && !this.rr.directory_loaded.includes(dirName) && this.curentLoad!==dirName){
      this.loadQueue=[...this.loadQueue, dirName]
      this._trayToStartLoad()
    }
  }
  /**Обновляет справочник (но только в том случае если он уже был загружен или грузится сейчас) */
  updateShortDirectory = (dirName) =>{
    if(!this.loadQueue.includes(dirName) && (this.rr.directory_loaded.includes(dirName) || this.curentLoad!==dirName)){
      this.loadQueue=[...this.loadQueue, dirName]
      this._trayToStartLoad()
    }
  }
  /**Пробуем запустить загрузку */
  _trayToStartLoad = () =>{
    if(!this.rr.api_directoryShort?.loading){
      if(this.loadQueue.length){
        const { getDirectoryShort=()=>{} } = this.rr.service_Api || {};
        const [ toLoad, ...restQueue] = this.loadQueue;
        this.curentLoad = toLoad;
        this.loadQueue = restQueue;
        getDirectoryShort({dictId:toLoad})
      }
    }
  }

  //внутренние функции
  _storeListener = () => {

    if (this._isChange('api_directoryShort')) {
      const {loading, data, error} = this.rr.api_directoryShort || {}
      if(!loading){
        if(!error){
          const oldShorts = this.rr.directory_shorts || {};
          const newShorts = {...oldShorts};
          newShorts[this.curentLoad]=data;
          this.actions.setDirectoryShorts(newShorts)
          this.actions.setDirectoryLoaded(...this.rr.directory_loaded, this.curentLoad)
        }
        this._trayToStartLoad()
      }
    }else if(this._isChange('api_planWorkDir')){
      const {loading, data, error} = this.rr.api_planWorkDir || {}
      if(!loading){
        if(!error){
          const oldShorts = this.rr.directory_shorts || {};
          const newShorts = {...oldShorts};
          newShorts.planWorkDir=data;
          this.actions.setDirectoryShorts(newShorts)
        }
      }
    }else if(this._isChange('api_planScheduleStatuses')){
      const {loading, data, error} = this.rr.api_planScheduleStatuses || {}
      if(!loading){
        if(!error){
          const oldShorts = this.rr.directory_shorts || {};
          const newShorts = {...oldShorts};
          newShorts.planScheduleStatuses=data;
          this.actions.setDirectoryShorts(newShorts)
        }
      }
    }else if(this._isChange('api_orderWorkStatuses')){
      const {loading, data, error} = this.rr.api_orderWorkStatuses || {}
      if(!loading){
        if(!error){
          const oldShorts = this.rr.directory_shorts || {};
          const newShorts = {...oldShorts};
          newShorts.orderWorkStatuses=data;
          this.actions.setDirectoryShorts(newShorts)
        }
      }
    }
  }
}